import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=ea0988ec&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=ea0988ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0988ec",
  null
  
)

export default component.exports